import { PointerWithRecord } from "libs/schema";
import { IListOnEntryActionEvent, IListRef } from "~/components/list";
import { useMemo } from "react";
import { IThreadViewContext } from "~/pages/thread/context";
import { ClientEnvironment } from "~/environment/ClientEnvironment";
import { isModKeyActive } from "~/environment/command.service";
import { UnreachableCaseError } from "libs/errors";

export type TDoneEntry = PointerWithRecord<"notification">;

/* -----------------------------------------------------------------------------------------------*/

export function useDoneViewThreadContext(props: { listRef: React.RefObject<IListRef<TDoneEntry>> }) {
  const { listRef } = props;

  return useMemo((): IThreadViewContext => {
    return { threadList: { type: "done", ref: listRef } };
  }, [listRef]);
}

/* -----------------------------------------------------------------------------------------------*/

export async function onDoneEntrySelect(
  environment: Pick<ClientEnvironment, "router">,
  props: {
    event: IListOnEntryActionEvent<TDoneEntry>;
  },
) {
  const { event } = props;

  switch (event.entry.table) {
    case "notification": {
      return environment.router.navigate(`/done/threads/${event.entry.record.thread_id}`, {
        openInNewTab: isModKeyActive(event.event),
      });
    }
    default: {
      throw new UnreachableCaseError(event.entry.table);
    }
  }
}

/* -----------------------------------------------------------------------------------------------*/
